import React, { useEffect, useState } from "react"
import "./progress_bar.scss"

export const ProgressBar = () => {
  const [scroll, setScroll] = useState(0)

  useEffect(() => {
    const scrollCalc = () => {
      const scrollTotal = document.documentElement.scrollTop
      const heightWin =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight
      const scrollPercentage = (scrollTotal / heightWin) * 100
      const sectionPercentage = 100 / 6
      const updateScroll = (curWidth: number) => {
        if (curWidth !== scroll) {
          setScroll(curWidth)
        }
      }

      if (scrollPercentage >= sectionPercentage * 6) {
        updateScroll(6)
      } else if (scrollPercentage >= sectionPercentage * 5) {
        updateScroll(5)
      } else if (scrollPercentage >= sectionPercentage * 4) {
        updateScroll(4)
      } else if (scrollPercentage >= sectionPercentage * 3) {
        updateScroll(3)
      } else if (scrollPercentage >= sectionPercentage * 2) {
        updateScroll(2)
      } else if (scrollPercentage >= sectionPercentage * 1) {
        updateScroll(1)
      } else {
        updateScroll(0)
      }
    }

    window.addEventListener(`scroll`, scrollCalc)
    return function cleanup() {
      window.removeEventListener(`scroll`, scrollCalc)
    }
  })

  const progressMainStyle = {
    height: `8px`,
    width: `${(scroll / 6) * 100}%`,
  }

  const barColor = (color: string) => (
    <div className={`progress-gradient gradient-${color}`} />
  )

  const fullBar = [
    barColor(`purple`),
    barColor(`green`),
    barColor(`red-purple`),
    barColor(`blue`),
    barColor(`orange`),
    barColor(`yellow`),
  ]

  return (
    <div className="progress-bar">
      <div className="bar" style={progressMainStyle}>
        {fullBar.slice(0, scroll).map((bar, i) => bar)}
      </div>
    </div>
  )
}
